import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, MessageSquare, HelpCircle, Mail } from "lucide-react";
import axios from "axios";

import { API } from "@/apiConfig";
import { ActivityPeriodSelector, Cockpit } from "@/pages/admin/Activity";

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/stats`).then(r => setStats(r.data)).catch(() => {});
  }, []);

  const cards = stats ? [
    { icon: FileText, label: "Articles", value: stats.articles, sub: stats.published_articles === stats.articles ? null : `${stats.published_articles} publiés`, href: "/admin/articles", color: "bg-sage/10 text-sage" },
    { icon: MessageSquare, label: "Témoignages", value: stats.testimonials, sub: "Affichés sur le site", href: "/admin/temoignages", color: "bg-terracotta/10 text-terracotta" },
    { icon: HelpCircle, label: "FAQ", value: stats.faq, sub: "Questions-réponses", href: "/admin/faq", color: "bg-sage/10 text-sage" },
    { icon: Mail, label: "Messages", value: stats.contacts, sub: stats.unread_contacts > 0 ? `${stats.unread_contacts} non lu${stats.unread_contacts > 1 ? "s" : ""}` : null, href: "/admin/messagerie", color: stats.unread_contacts > 0 ? "bg-red-100 text-red-500" : "bg-terracotta/10 text-terracotta" },
  ] : [];

  return (
    <div className="space-y-4">
      <div>
        <h1 className="font-playfair text-3xl text-charcoal">Tableau de bord</h1>
        <p className="font-manrope text-sm text-charcoal-muted mt-0.5">L'essentiel de votre activité, en un regard.</p>
      </div>

      <div className="grid lg:grid-cols-[minmax(280px,1fr)_minmax(0,2fr)] lg:gap-4">
        <div className="lg:col-start-2"><ActivityPeriodSelector /></div>
      </div>

      {/* Content status */}
      <section aria-labelledby="content-status-title">
        <h2 id="content-status-title" className="font-manrope font-medium text-xs text-charcoal-muted uppercase tracking-wider mb-2">Contenus du site</h2>
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-4">
        {stats ? cards.map((c, i) => (
          <Link key={i} to={c.href} data-testid={`stat-card-${i}`}
            className="group flex h-16 items-center gap-3 rounded-xl border border-sage/10 bg-white px-3 py-2.5 transition-all duration-200 hover:border-sage/30 hover:shadow-sm">
            <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${c.color}`}>
              <c.icon size={15} />
            </div>
            <div className="flex h-8 min-w-0 flex-col justify-center">
              <div className="font-manrope text-xs font-medium text-charcoal">{c.label}</div>
              {c.sub&&<div className="truncate font-manrope text-[11px] text-charcoal-muted">{c.sub}</div>}
            </div>
            <div className="ml-auto whitespace-nowrap font-playfair text-xl leading-none tabular-nums text-charcoal">{c.value}</div>
          </Link>
        )) : (
          [1, 2, 3, 4].map(i => <div key={i} className="h-16 animate-pulse rounded-xl border border-sage/10 bg-white" />)
        )}
        </div>
      </section>

      <div id="calendrier">
        <Cockpit />
      </div>
    </div>
  );
}
